<template>
  <div class="pop-out" @click="cancle">
    <div class="detainment" @click="stopBubble">
      <h2>看不懂产品？预约专家咨询</h2>
      <div class="content-wrap">
        <div class="input-item clearfix">
          <span style="letter-spacing:.5em">姓 名：</span>
          <input type="text" v-model="userInfo.realName" />
        </div>
        <div class="input-item clearfix">
          <span style="letter-spacing:.5em">性 别：</span>
          <div class="checkWrap">
            <img src="@/assets/images/icon-select-1.png" class="checkImg" v-if="userInfo.sex==2" />
            <img
              src="@/assets/images/icon-select-0.png"
              class="checkImg"
              v-else
              @click="handleChangeSex"
            />
            <label style="margin:0 20px 0 8px">女士</label>

            <img src="@/assets/images/icon-select-1.png" class="checkImg" v-if="userInfo.sex==1" />
            <img
              src="@/assets/images/icon-select-0.png"
              class="checkImg"
              v-else
              @click="handleChangeSex"
            />
            <label style="margin:0 20px 0 8px">先生</label>
          </div>
        </div>
        <div class="input-item clearfix">
          <span>手 机 号 ：</span>
          <input type="tel" v-model="userInfo.phone" maxlength="11" @input="handleChangePhone" />
        </div>
        <div class="input-item input-item1 clearfix" v-show="!showPhoneCodeFlag">
          <span>验 证 码 ：</span>
          <input
            type="tel"
            v-model="userInfo.phoneCode"
            maxlength="6"
            placeholder="请输入验证码"
            style="font-size:.28rem"
          />
          <div
            class="get-code"
            :class="{'disabled': getCodeText !== '获取验证码'}"
            @click="getSmsCode"
          >{{getCodeText}}</div>
        </div>
        <div>
          <p style="color:gray;margin-top:.2rem">温馨提示</p>
          <span class="yuyue">预约成功后，产品专家会在24小时内跟您电话联系</span>
          <!-- <span class="yuyue">2.未注册平安健康账号的手机号,首次登录时将自动注册平安健康账号</span> -->
        </div>

        <!-- 按钮 -->
        <div class="button-wrap clearfix" style="margin-top:0.2rem">
          <div>
            <div class="leave-no" @click.stop="leaveNO()">
              <a href="javascript:;">取消</a>
            </div>
          </div>
          <div>
            <div class="continue-ok" @click.stop="continueOK()">
              <a href="javascript:;">提交</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 根api地址，通过环境变量的配置获取
const API_PATH = process.env.VUE_APP_API_URL;
// 获取验证码，前置校验接口，是否需要滑块验证
const API_CHECK_SMS_CODE = `${API_PATH}/mapi/user/userBase/baseAPI/checkSmsCode.json`;
// 滑块初始化注册
const API_SMS_REGISTER = `${API_PATH}/mapi/user/userBase/baseAPI/smsRegister.json`;
// 滑块二次校验
const API_SMS_CODE = `${API_PATH}/mapi/user/userBase/baseAPI/smsCode.json`;
// 短信验证及投保人账号信息查询
const API_USER_QUERY = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceWebUserQuery.json`;
// 立即投保注册
const API_INS_WEB_REGISTER = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceWebRegist.json`;
const regPhone = /^(1[3-9])\d{9}$/; // 检测手机号
import base from "../mixins/base";
export default {
  name: "ConsultQuestion",
  mixins: [base],
  props: {
    secretPolicyUrl: String,
    insId: String,
    userInfoObj: Object,
    flag: String,
    showPhoneCode: Boolean,
    totalInfo: Object
  },
  mounted() {
    const { realName, phone, sex } = this.userInfoObj;
    if (phone) {
      this.userInfo.phone = phone;
    }
    if (realName) {
      this.userInfo.realName = realName;
    }
    if (sex) {
      this.userInfo.sex = sex;
    }
    this.showPhoneCodeFlag = this.showPhoneCode;
  },
  data() {
    return {
      userInfo: {
        realName: null,
        sex: 2, //1男 2女
        phone: null,
        isRead: false,
        phoneCode: null
      },
      getCodeText: "获取验证码",
      onGetCode: false,
      showPhoneCodeFlag: false,
      isCheck: false
    };
  },
  methods: {
    // 阻止冒泡
    stopBubble(e) {
      // 非 IE 浏览器 (点击弹窗其他区域关闭)
      if (e && e.stopPropagation) {
        e.stopPropagation();
        return;
      }
      // IE 浏览器
      window.event.cancelBubble = true;
    },
    // 输入手机号
    handleChangePhone() {
      if (this.showPhoneCodeFlag) {
        this.userInfo.phone = null;
      }
      this.showPhoneCodeFlag = false;
    },
    goToThirdPage(e) {
      let url = e.target.getAttribute("data-url");
      let title = e.target.text || "";
      this.$router.push({
        name: "ThirdPage",
        query: {
          url: url,
          title: title,
          sex: 1
        }
      });
    },
    cancle() {
      this.$emit("cancleCommit");
    },
    // 取消
    leaveNO() {
      // this.flag === "back"
      //   ? (location.href = "https://m.health.pingan.com")
      //   : this.$emit("cancleCommit");
      this.$emit("cancleCommit");
    },
    // 提交
    async continueOK() {
      let realName = this.userInfo.realName,
        sex = this.userInfo.sex,
        phone = this.userInfo.phone;
      if (!realName || !sex || !phone) {
        this.showToast("您有信息未填写");
        return;
      }
      const regPhone = /^(1[3-9])\d{9}$/; // 检测手机号
      if (!this.showPhoneCodeFlag) {
        if (!regPhone.test(phone)) {
          this.showToast("请输入正确的手机号");
          return;
        }
      }
      /*if (!this.userInfo.isRead) {
        this.showToast("请勾选平安健康隐私政策");
        return;
      }*/

      // 手机号自己输入
      if (!this.showPhoneCodeFlag && !this.userInfo.phoneCode) {
        this.showToast("请输入验证码");
        return;
      }

      // 手机号自己输入
      // if (!this.showPhoneCodeFlag) {
      //   let params1 = {
      //     phone: this.userInfo.phone,
      //     smsCode: this.userInfo.phoneCode, //验证码
      //     source: "8"
      //   };
      //   const response = await axios.post(API_USER_QUERY, params1);
      //   if (response.code === 1) {
      //     this.isCheck = true;
      //   } else {
      //     this.isCheck = false;
      //     this.showToast(response.msg);
      //     return;
      //   }
      // }
      // 手机号自己输入
      // if (!this.showPhoneCodeFlag && !this.isCheck) {
      //   this.showToast("请输入正确的验证码");
      //   return;
      // }

      let url =
        API_PATH +
        "/mapi/serviceOnLineMakeAppoint.json?deviceld=5a4c935cbb6ff6ca&deviceType=SM-G9300&timestamp" +
        parseInt(new Date().getTime() / 1000) +
        "app=0&platform=3&app_key=PAHealth&osversion=23&info=&version=1.0.1&resolution=1440x2560&screenSize=22&netType=1&channel=mar_m_ikblnsj";
      let params = {
        // realName,
        sex,
        // phone,
        // phoneCode: null,
        clueType: "预约咨询", //线索类别
        clueSource: "M站产品专家预约", //线索来源
        clueGrade: "B", //线索等级
        visitTime: null, //接电话时间
        insId: this.insId //产品id
      };
      params.realName = this.showPhoneCodeFlag
        ? this.totalInfo.realName
        : realName;
      params.phone = this.showPhoneCodeFlag ? this.totalInfo.phone : phone;
      if (!this.showPhoneCodeFlag) {
        params.phoneCode = this.userInfo.phoneCode;
      }
      axios
        .post(url, params)
        .then(res => {
          if (res.code == 1) {
            // this.showToast("恭喜您,提交成功");
            // this.$dataTrack.track("commit_appo_conse", "提交预约专家咨询");
            this.$emit("toastSuccess");
            // this.goInsRegister(); //提交时注册
            this.userInfo.realName = null;
            this.userInfo.phone = null;
            // this.userInfo.phoneCode = null;
            this.userInfo.isRead = false;
            this.userInfo.sex = 2;
          } else {
            this.showToast(res.msg);
          }
        })
        .catch(() => {
          this.showToast("网络出错，请重试");
        });
    },
    // 切换性别
    handleChangeSex() {
      this.userInfo.sex = this.userInfo.sex === 1 ? 2 : 1;
    },
    // 验证码框失去焦点触发
    onSmsCodeChange() {
      setTimeout(() => {
        if (this.userInfo.phoneCode.length === 6) {
          if (!regPhone.test(this.userInfo.phone)) {
            this.showToast("请检查手机号是否正确");
            return;
          } else {
            this.queryUserInfo(); // 根据手机号验证码查询用户
          }
        }
      }, 0);
    },
    // 根据手机号验证码查询用户
    queryUserInfo() {
      let params = {
        phone: this.userInfo.phone,
        smsCode: this.userInfo.phoneCode, //验证码
        source: "8"
      };
      axios
        .post(API_USER_QUERY, params)
        .then(response => {
          if (response.code === 1) {
            this.isCheck = true;
          } else {
            this.isCheck = false;
            this.showToast(response.msg);
          }
        })
        .catch(error => {
          this.showToast("网络异常！");
        });
    },
    // 发送验证码
    // getSmsCode() {
    //   if (this.onGetCode) {
    //     return;
    //   }
    //   if (this.getCodeText !== "获取验证码") {
    //     return;
    //   }
    //   if (!regPhone.test(this.userInfo.phone)) {
    //     this.onGetCode = false;
    //     this.showToast("请输入正确的手机号");
    //     return;
    //   }
    //   this.onGetCode = true;
    //   this.getCodeText = "获取中";
    //   Login.getNewSmsCode(this.userInfo.phone, (time) => {
    //     this.countDownTime(time);
    //   });
    // },
    //获取短信验证码
    getSmsCode() {
      if (this.onGetCode) {
        return;
      }
      if (this.getCodeText !== "获取验证码") {
        return;
      }
      if (!regPhone.test(this.userInfo.phone)) {
        this.onGetCode = false;
        this.showToast("请输入正确的手机号");
        return;
      }
      this.onGetCode = true;
      this.getCodeText = "获取中";
      let params = {
        phone: this.userInfo.phone,
        source: "3"
      };
      axios
        .post(API_CHECK_SMS_CODE, params)
        .then(response => {
          if (response.code === 1) {
            let data = response.data;
            if (typeof data.step != "undefined" && data.step == "needcaptcha") {
              // 需要滑块验证
              this.initGeetest();
            } else {
              // 倒计时
              this.countDownTime(data.interval);
            }
          } else {
            this.showToast(response.msg);
            this.onGetCode = false;
            this.getCodeText = "获取验证码";
          }
        })
        .catch(error => {
          this.onGetCode = false;
          this.getCodeText = "获取验证码";
          this.showToast("网络异常！");
        });
    },
    // 初始化平安滑块
    initGeetest() {
      let self = this;
      axios
        .post(API_SMS_REGISTER, {
          phone: this.userInfo.phone,
          platform: 8,
          source: "8"
        })
        .then(result => {
          loadScript(`${API_PATH}/share/script/services/gt.js`, () => {
            initGeetest(
              {
                gt: result.gt,
                challenge: result.challenge,
                offline: !result.success,
                new_captcha: true,
                api_server:
                  process.env.VUE_APP_MODE === "production"
                    ? "https://captcha-api.pingan.com"
                    : "https://captcha-api-stg.pingan.com:10530",
                product: "bind",
                https: true
              },
              function(captchaObj) {
                captchaObj
                  .onReady(function() {
                    captchaObj.verify();
                  })
                  .onSuccess(function() {
                    self.checkSmsCode(captchaObj.getValidate());
                  })
                  .onError(function() {
                    self.showToast("安全验证组件启动失败，请重试");
                  });
                setTimeout(() => {
                  self.onGetCode = false;
                  self.getCodeText = "获取验证码";
                }, 2000);
              }
            );
          });
        })
        .catch(error => {
          this.onGetCode = false;
          this.getCodeText = "获取验证码";
          this.showToast("网络异常！");
        });
    },
    // // 二次验证
    checkSmsCode(data) {
      this.onGetCode = true;
      let params = {
        source: "3",
        phone: this.userInfo.phone,
        challenge: data.geetest_challenge,
        validate: data.geetest_validate,
        seccode: data.geetest_seccode
      };
      axios
        .post(API_SMS_CODE, params)
        .then(response => {
          if (response.code === 1) {
            this.countDownTime(response.data.interval);
          } else {
            this.onGetCode = false;
            this.getCodeText = "获取验证码";
            this.showToast(response.msg);
          }
        })
        .catch(error => {
          this.showToast("网络异常！");
          this.onGetCode = false;
          this.getCodeText = "获取验证码";
        });
    },
    // // 验证码倒计时
    countDownTime(interval) {
      let vm = this;
      let leftTime = interval || 60;
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
      }
      this.intervalTimer = setInterval(() => {
        if (leftTime == 1) {
          vm.getCodeText = "获取验证码";
          clearInterval(vm.intervalTimer);
          vm.onGetCode = false;
          return;
        } else {
          leftTime = leftTime - 1;
          vm.getCodeText = "(" + leftTime + "s)";
        }
      }, 1000);
    }
    // 登录接口
    // https://m.health.pingan.com/mapi/login.json?deviceId=5a4c935cbb6ff6ca&deviceType=SM-G9300&timestamp=1594878117&app=0&platform=3&app_key=PAHealth&osversion=23&info=&version=1.0.1&resolution=1440x2560&screenSize=22&netType=1&channel=m_h5&sourceUserId=0&sourcePhone=&agentCode=null&agentChannel=null

    // phone: 18251833918
    // smsCode: 137044
    // deviceId: 5a4c935cbb6ff6ca
    // deviceType: SM-G9300
    // timestamp: 1594878509
    // app: 0
    // platform: 3
    // app_key: PAHealth
    // osversion: 23
    // info:
    // version: 1.0.1
    // resolution: 1440x2560
    // screenSize: 22
    // netType: 1
    // channel: m_h5
    // sourceUserId: 0
    // sourcePhone:
    // agentCode: null
    // agentChannel: null
    // async queryLogin() {
    //   let url =
    //     API_PATH +
    //     "/mapi/login.json?deviceld=5a4c935cbb6ff6ca&deviceType=SM-G9300&timestamp" +
    //     parseInt(new Date().getTime() / 1000) +
    //     "app=0&platform=3&app_key=PAHealth&osversion=23&info=&version=1.0.1&resolution=1440x2560&screenSize=22&netType=1&channel=m_h5&sourceUserId=0&sourcePhone=&agentCode=null&agentChannel=null";
    //   let params = {
    //     phone: this.userInfo.phone,
    //     smsCode: this.userInfo.phoneCode
    //   };
    //   let res1 = await axios.post(url, params);
    //   if (res1.code == 1) {
    //   }
    // }
  }
};
</script>
<style scoped>
.pop-out {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.detainment {
  position: absolute;
  left: 51%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 6.3rem;
  /* height: 6.71rem; */
  background-color: #fff;
  font-weight: 400;

  font-size: 0.28rem;
  color: #333333;
  padding: 0.3rem 0.4rem 0.5rem;
  box-sizing: border-box;
  border-radius: 5px;
}
h2 {
  font-size: 16px;
  text-align: center;
}
.content-wrap {
  width: 95%;
  /* text-align: center; */
}
.content-wrap .input-item {
  /* margin-top: 0.02rem; */
  height: 1rem;
}
.content-wrap .input-item span {
  /* display: inline-block; */
  margin-top: 0.44rem;
  width: 30%;
  text-align: left;
  float: left;
}
.content-wrap .input-item input[type="text"],
.content-wrap .input-item input[type="tel"] {
  /* display: inline-block; */
  width: 70%;
  margin-top: 0.35rem;
  height: 0.6rem;
  float: left;
  border: 1px solid #eee;
  padding: 0 0.1rem;
  appearance: none;
  font-size: 0.28rem;
}
.yuyue {
  font-size: 0.2rem;
  color: gray;
  display: inline-block;
  margin-top: 0.05rem;
}
.read {
  margin-top: 0.3rem;
}
.read a {
  font-size: 0.24rem;
}
.button-wrap > div {
  float: left;
  width: 50%;
  height: 0.7rem;
  margin-bottom: 0.2rem;
}
.clearfix:after {
  content: "";
  display: block;
  clear: both;
}
.continue-ok {
  /* width: 2.7rem; */
  width: 90%;
  height: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(254, 106, 7, 1);
  border-radius: 0.35rem;
  margin: 0.2rem auto;
}
.continue-ok a {
  color: #fff;
}

.leave-no {
  /* width: 2.7rem; */
  width: 90%;
  height: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(254, 106, 7, 1);
  border-radius: 0.35rem;
  margin: 0 auto;
  margin-top: 0.2rem;
}
.leave-no a {
  color: rgba(254, 106, 7, 1);
}
.checkWrap {
  display: inline-block;
  margin-top: 0.46rem;
  width: 70%;
  text-align: left;
}
.checkWrap .checkImg,
.read img {
  vertical-align: middle;
  width: 0.3rem;
}
.checkWrap label {
  margin-right: 5px;
}
.input-item1 {
  position: relative;
}
.get-code {
  position: absolute;
  right: 3px;
  top: 0.34rem;
  width: 1.5rem;
  height: 0.5rem;
  text-align: center;
  line-height: 0.6rem;
  font-size: 0.26rem;
  color: #ff6600;
  /* background: url("../assets/images/icon-rect.png") no-repeat;
  background-size: 100% 100%; */
}
.disabled {
  opacity: 0.6;
  color: #999 !important;
}
</style>
